<template>
    <div>
        <!-- Start Breadcrumbs -->
        <div class="breadcrumbs">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">My Favorites</h1>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-12">
                        <ul class="breadcrumb-nav">
                            <li><router-link to="/">Home</router-link></li>
                            <li>My Favorites</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Breadcrumbs -->

        <!-- Start Dashboard Section -->
        <section class="dashboard section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-12">
                        <div class="main-content">
                            <div class="dashboard-block mt-0">
                                <h3 class="block-title">Favorite Products</h3>
                                <!-- Start Items Area -->
                                <div class="my-items">
                                    <!-- Start List Title -->
                                    <div class="item-list-title">
                                        <div class="row align-items-center">
                                            <div class="col-lg-5 col-md-5 col-12">
                                                <p>Product</p>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-12">
                                                <p>Category</p>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-12">
                                                <p>Date Added</p>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-12 align-right">
                                                <p>Action</p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- End List Title -->
                                    <favorite-item-vue/>
                                </div>
                                <!-- End Items Area -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Dashboard Section -->
    </div>
</template>

<script>
import FavoriteItemVue from '../components/FavoriteItem.vue'


export default {
name: 'FavoritesList',
components:{
    FavoriteItemVue
},
 created() {
    this.$store.dispatch("fetchFavorites");
    if (localStorage.access_token) {
        this.$store.dispatch("checkToken")
          .then(() => {
            let payload = { status: true };
            this.$store.commit("SET_LOGIN_STATUS", payload);
          })
          .catch((err) => {
            let payload = { status: false };
            this.$store.commit("SET_LOGIN_STATUS", payload);
            localStorage.clear();
            this.$router.push("/").catch(()=>{})
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.message,
              showCloseButton: true,
              showConfirmButton: false,
            });
          });
      } else {
        let payload = { status: false };
        this.$store.commit("SET_LOGIN_STATUS", payload);
        localStorage.clear();
        this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: 'Please login first',
              showCloseButton: true,
              showConfirmButton: false,
            });
        this.$router.push("/").catch(()=>{})
      }
  },


}
</script>

<style>

</style>